import { BaseEntity } from "./system";
import { Marketplace } from "./Publishing";

// Mirrors GPMetals.Core.Entities.ListingRestrictionAction. Enums come over the wire as numbers.
export enum ListingRestrictionAction {
  Warn = 0,
  Block = 1,
}

export const listingRestrictionActionLabel: Record<ListingRestrictionAction, string> = {
  [ListingRestrictionAction.Warn]: "Warn",
  [ListingRestrictionAction.Block]: "Block",
};

export interface IListingRestrictionRuleCategory {
  id: string;
  listingRestrictionRuleId: string;
  partCategoryId: string;
}

export interface IListingRestrictionRule extends BaseEntity {
  name: string;
  marketplace: Marketplace;
  action: ListingRestrictionAction;
  keywords?: string | null;
  excludeKeywords?: string | null;
  reason?: string | null;
  isActive: boolean;
  categories: IListingRestrictionRuleCategory[];
}

export interface CreateUpdateListingRestrictionRuleRequest {
  name: string;
  marketplace: Marketplace;
  action: ListingRestrictionAction;
  keywords: string;
  excludeKeywords: string;
  reason: string;
  isActive: boolean;
  categoryIds: string[];
}
